export default __webpack_public_path__ + "static/nataliap-2b35c4c7f84643e013d90672f55ade1f.jpg";